import React, { MouseEventHandler, useContext } from 'react';
import styles from '../../../styles/logpost.module.css';
import BlocksFtux from '../../../assets/icons/BlocksFtux';
import { Button } from '../../styledComponents';
import AddIcon from '../../../assets/icons/AddIcon';
import { Spacer } from '../../common';
import { InboundContext } from '../../../context/InboundContext';

interface Props {
  onAddPostClick?: MouseEventHandler<HTMLButtonElement>;
}

export default function LogPostFtux({ onAddPostClick }: Props) {
  const { inboundData } = useContext(InboundContext);

  return (
    <div className={styles.logPostFtuxContainer}>
      <BlocksFtux />
      <Spacer spacing="27px" />
      <div className={styles.logPostFtuxText}>
        Add your posts here to submit it to {inboundData?.landingPage.brandName || 'the brand'}.
      </div>
      <Spacer spacing="32px" />
      <Button bgColor="#7F38E9" onClick={onAddPostClick}>
        <AddIcon width={28} height={28} />
        Add Post
      </Button>
    </div>
  );
}
